// ROUTE URL
export const ROUTE_URL = {
  RATING: 'rating',
}
